require('../node_modules/slick-carousel/slick/slick.css');
require('../node_modules/slick-carousel/slick/slick-theme.css');

require('./scss/app.scss');
require('./js/menu');
require('./js/share');
require('./js/slider');
require('./js/search');
require('./js/inputs');
require('./js/validate');
require('./js/news-grid');

